"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const NumberInput_1 = __importDefault(require("src/components/shared/NumberInput"));
const InputWeight = ({ objective, isAllowToUpdate, isLocked }) => {
    const [isRender, setRender] = (0, react_1.useState)(false);
    const handleChangeWeightInput = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.handleChangeWeightInput);
    const isPercentage = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.isPercentage);
    const onChangeInput = (value) => {
        if (isRender) {
            handleChangeWeightInput(objective?.id, parseFloat(value));
        }
        else {
            setRender(true);
        }
    };
    return (react_1.default.createElement(NumberInput_1.default, { className: `styled-input !m-[0px] ${isPercentage ? 'w-[80px]' : 'w-full'}`, inputClass: "m-[0px]", value: objective?.weight?.toString() || 0, onChange: onChangeInput, max: 100, precision: 13, disabled: !isAllowToUpdate || (isPercentage ? false : isLocked), dataCy: "weight-percentage", htmlFor: `input-${objective?.id}`, ableToInputZero: true }));
};
exports.default = InputWeight;
